import React,{useState} from 'react';
import Modal from 'react-responsive-modal';
import ChannelService from 'services/ChannelService';
import {injectIntl} from 'react-intl';
import { Select } from 'components/FormElements';
import { Form } from 'react-form';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import { required, validFixedLine } from 'constants/InputErrors';

class DismissModal extends React.Component {
    
    constructor( props ) {
      super( props );

      this.state = {
        reasons:[]
      };
      this.sendReason = this.sendReason.bind( this );

    }

    componentWillReceiveProps( nextProps ) {
        if( !this.props.opened && nextProps.opened ) {
            this.getData();
        }
    }

    getData = () => {
        ChannelService.getDismissReason().then((response)=>{
            if ( !response.errors ) this.setState({reasons:_.orderBy(response.data.data,'description')});
        })
    }

    sendReason = (data) => {
        this.props.onConfirm(data);
     }

     reasonKeyDown = (keyD) => {
        if (keyD.keyCode === 13) {
            const rep = this.state.reasons.filter(item => {return item.description === keyD.target.value}).length;
            if(rep === 0){
                this.setState( {reasons:[...this.state.reasons, {description:keyD.target.value, id:keyD.target.value}]})
            } 
        }
      }

    render() {
        return (
            <Modal closeOnEsc={false}
            little
            modalClassName="col-md-4"
            onClose={this.props.onToggle}
            open={this.props.opened}
            showCloseIcon={false}
     >
       <div className="text-center">
         <i className="fa fa-warning text-large color-warning"/>
         <h5>{this.props.label || 'Are you sure?'}</h5>
       </div>
       <Form onSubmit={this.sendReason}
       validate={( values ) => {
        return {
          reason: required( values.reason ),
        }
      }}
       >
           {({submitForm}) =>
       <form onSubmit={submitForm}>
       <Select field="reason" className="form-control" placeholder="Reason"
                labelKey="description"
                valueKey="description"
                value={this.state.selectedRason}
                onChange={value=> this.setState({selectedRason:value})}
                options={this.state.reasons}
                onInputKeyDown={this.reasonKeyDown}
                />
       
       <hr/>
       <div className="text-right">
         <button type="submit" className="btn btn-danger mr-3">{ this.props.intl.formatMessage( { id: 'yes' } ) }</button>
         <button className="btn btn-outline-secondary" onClick={this.props.onToggle}>{ this.props.intl.formatMessage( { id: 'cancel' } ) }</button>
       </div>
       </form>
    }
       </Form>
     </Modal>
            )
    }

}

module.exports = injectIntl(DismissModal)


// WEBPACK FOOTER //
// ./components/HTMLElements/DismissModal/index.js